// Version : 0.0.1
// Author : Vignesh
// LastEdit : Vignesh
// Last ADD : REMOVED UNUSED SAGA
// MODIFIED DATE: 26-09-2025

import { takeLatest, put, all, call } from 'redux-saga/effects';
import repaymentCollectionReportTypes from './repayment-collection-report.types';
import { fetchPostRepaymentCollection } from './repayment-collection-report.services';
import {
	fetchPostRepaymentCollectionSuccess,
	fetchPostRepaymentCollectionFailure,
	fetchPostRepaymentCollectionChanged,
} from './repayment-collection-report.action';
import { encryptData } from '../../_common/enode-decode';

import AlertManager from '../../../utils/alertManager';
/************* FETCH REPAYMENT COLLECTION REPORT START *********************** */

export function* fetchPostRepaymentCollectionCall({ payload }: any) {
	try {
		const {
			companyID,
			databaseName,
			fromDate,
			toDate,
			branchID,
			centerID,
			groupID,
			memberID,
			funderID,
			limit,
			isBusiness,
			dateType,
			collectionMode,
			isShowAutoLoan,
		} = payload;
		const key = 'RepaymentCollectionListKey';
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			FromDate: fromDate,
			ToDate: toDate,
			BranchID: branchID,
			CenterID: centerID,
			GroupID: groupID,
			MemberID: memberID,
			FunderID: funderID,
			Limit: limit,
			IsBusiness: isBusiness,
			DateType: dateType,
			CollectionMode: collectionMode,
			IsAutoLoan: isShowAutoLoan,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchPostRepaymentCollection, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchPostRepaymentCollectionFailure(responseData.data));
		} else {
			yield put(fetchPostRepaymentCollectionSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchPostRepaymentCollectionFailure(error));
	}
}

export function* onSelectPostRepaymentCollection() {
	yield takeLatest(
		repaymentCollectionReportTypes.FETCH_POST_REPAYMENT_COLLECTION_START,
		fetchPostRepaymentCollectionCall,
	);
}

export function* fetchPostRepaymentCollectionReset() {
	yield put(fetchPostRepaymentCollectionChanged());
}

export function* onSelectPostRepaymentCollectionReset() {
	yield takeLatest(
		repaymentCollectionReportTypes.FETCH_POST_REPAYMENT_COLLECTION_RESET,
		fetchPostRepaymentCollectionReset,
	);
}

export function* repaymentCollectionReportSaga() {
	yield all([call(onSelectPostRepaymentCollection), call(onSelectPostRepaymentCollectionReset)]);
}

/************* FETCH REPAYMENT COLLECTION REPORT END *********************** */
